// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = "9.3.3.0";
export const CURRENT_BRANCH = "master";
/* tslint:enable */
